import _classCallCheck from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

var FixedYAxis = /*#__PURE__*/function () {
  function FixedYAxis() {
    _classCallCheck(this, FixedYAxis);
  }

  _createClass(FixedYAxis, [{
    key: "activate",
    value: function activate(dygraph) {
      var valueRange = dygraph.getOption('valueRange');

      if (!valueRange) {
        throw new Error('No valueRange set');
      }

      var getExtremeYValues = function getExtremeYValues() {
        return valueRange;
      };

      var predraw = function predraw(e) {
        var newRange = dygraph.getOption('valueRange');

        if (valueRange[0] !== newRange[0] || valueRange[1] !== newRange[1]) {
          valueRange = newRange;
        }

        e.dygraph.dataHandler_.getExtremeYValues = getExtremeYValues;
      }; // Default value of 0.1 will add 10% Y-axis padding


      dygraph.updateOptions({
        yRangePad: 0
      }, true); // Must override dataHandler.getExtremeYValues every predraw

      return {
        predraw: predraw
      };
    }
  }]);

  return FixedYAxis;
}();

export { FixedYAxis as default };

FixedYAxis.toString = function () {
  return 'FixedYAxis Plugin';
};